import { render, staticRenderFns } from "./recent-search-results.vue?vue&type=template&id=61cec7a2&scoped=true&"
import script from "./recent-search-results.vue?vue&type=script&lang=js&"
export * from "./recent-search-results.vue?vue&type=script&lang=js&"
import style0 from "./recent-search-results.vue?vue&type=style&index=0&id=61cec7a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cec7a2",
  null
  
)

export default component.exports